<div class="lvi-content">
    <div class="avatar">
        <i class="nio icon-profil"></i>
    </div>
    <div class="lvi-body">
        <div class="title">
            <a (click)="navigateTo()">{{ data | user:'nomPrenom' }}</a>
        </div>
        <ul class="lvi-attrs">
            <li>
                <strong [translate]="'admin.entreprise.utilisateurs.internes.identifiant'"></strong>
                <span>{{ data.nomAcces }}</span>
            </li>
            <li *ngIf="data.matricule">
                <strong [translate]="'admin.entreprise.utilisateurs.internes.matricule'"></strong>
                <span>{{ data.matricule }}</span>
            </li>
            <li *ngIf="data.orga">
                <strong [translate]="'admin.entreprise.utilisateurs.internes.serviceAffectation'"></strong>
                <span>{{ data | user:'orga' }}</span>
            </li>
            <li *ngIf="data.fonctions">
                <strong [translate]="'admin.entreprise.utilisateurs.internes.profils'"></strong>
                <span>{{ data | user:'fonctions' }}</span>
            </li>
            <li *ngIf="!data.actif && (!data.dateOut || data.statutOubli === StatutOubli.PROGRAMME || data.statutOubli === StatutOubli.EN_ATTENTE || data.statutOubli === StatutOubli.OUBLIE)">
                <strong [translate]="'admin.entreprise.utilisateurs.internes.eligibleOubli.title'"></strong>
                <span *ngIf="!data.dateOut" [translate]="'admin.entreprise.utilisateurs.internes.eligibleOubli.sansDateSortie'"></span>
                <ng-container *ngIf="data.dateOut">
                    <span *ngIf="data.statutOubli === StatutOubli.PROGRAMME">{{ 'admin.entreprise.utilisateurs.internes.eligibleOubli.programme' | translate:{date: data.dateStatutOubli | date:'shortDate'} }}</span>
                    <span *ngIf="data.statutOubli === StatutOubli.EN_ATTENTE">{{ 'admin.entreprise.utilisateurs.internes.eligibleOubli.attente' | translate:{date: data.dateStatutOubli | date:'shortDate'} }}</span>
                    <span *ngIf="data.statutOubli === StatutOubli.OUBLIE">{{ 'admin.entreprise.utilisateurs.internes.eligibleOubli.oublie' | translate:{date: data.dateStatutOubli | date:'shortDate'} }}</span>
                </ng-container>
            </li>
        </ul>
    </div>
</div>